import { LottiePlayer } from '@repo/design-system-kit';
import cx from 'clsx';
import consentStayInformedLottie from '../../assets/lotties/consent-stay-informed.json';
import styles from './value-proposition.module.css';

export interface ValuePropositionProps {
  className?: string;
}

export function ValueProposition({ className }: ValuePropositionProps): React.ReactElement {
  return (
    <div className={cx(styles.container, className)}>
      <div className={styles.content}>
        <div className={styles.lottieContainer}>
          <LottiePlayer
            animationData={consentStayInformedLottie as object}
            autoplay
            className={styles.lottie}
            loop
          />
        </div>
      </div>
    </div>
  );
}
